import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import utils from 'utils';
import { MODAL, GMI_SERVICE_PATHS } from 'constants';
import { breakpointSelector, isFetchingEndpointSelector, rateTypesSelector } from 'selectors';
import { selectCarClass } from 'actions/reservation/selectCarClass';
import { getCarClassDetails } from 'actions/reservation/getCarClassDetails';
import { openModal } from 'actions/modal/openModal';
import { getVehicleTermsContent } from 'selectors/vehicleSelectSelectors';
import { getReservationVolatileCurrencyIndicator } from 'selectors/reservationSelectors';
import VehicleSelectDetailsCard from './VehicleSelectDetailsCard';

const carClassDetailsServiceCode = `${GMI_SERVICE_PATHS.CAR_CLASS_DETAILS}?carClassCode=`;

const mapStateToProps = (state, props) => {
  const { vehicle } = props;
  const vehicleCode = vehicle.code;

  const { payLaterRates, prePayRates } = rateTypesSelector(state, { vehicleCode });
  return {
    breakpoint: breakpointSelector(state),
    vehicleTermsContent: getVehicleTermsContent(state, vehicle),
    payLaterRates,
    prePayRates,
    loadingDetails: isFetchingEndpointSelector(state, { endpoint: carClassDetailsServiceCode + vehicleCode }),
    reservationVolatileCurrencyIndicator: getReservationVolatileCurrencyIndicator(state),
  };
};

const actionCreators = {
  getCarClassDetails,
  selectCarClass,
  showTaxesFeesModal: (header, feesArray, taxesFeesTotal) =>
    openModal(MODAL.TAXES_FEES_MODAL, { props: { header, feesArray, taxesFeesTotal } }),
  showConvertedTotalsModal: () => openModal(MODAL.CURRENCY_CONVERSION_DETAILS_MODAL),
  showGuaranteedResModal: () => openModal(MODAL.GUARANTEED_RES),
  showCouponDoesNotApplyModal: (continueWithoutCoupon) =>
    openModal(MODAL.COUPON_DOES_NOT_APPLY, { props: { continueWithoutCoupon } }),
};

const actionCreatorsDispatchedManually = (dispatch, props) => ({
  showTermsOfUseModal: (code, description, prepay) => {
    dispatch(
      openModal(MODAL.VAN_SELECTED_12_AND_15_TERMS_USE, {
        props: {
          code,
          description,
          prepay,
        },
      })
    );
  },
  showLimitedInventoryVehicleModal: (code, prepay, description) => {
    const isTermsAndConditionsRequired = props.vehicle?.terms_and_conditions_required;
    dispatch(
      openModal(MODAL.LIMITED_INVENTORY_VEHICLE_MODAL, {
        props: {
          code,
          prepay,
          description,
          isTermsAndConditionsRequired,
        },
      })
    );
  },
  learnAboutPrepayAndPayLaterModal: () =>
    dispatch(
      openModal(MODAL.LEARN_ABOUT_PREPAY_AND_PAY_LATER, { props: { guaranteedRes: props.vehicle.guaranteed_vehicle } })
    ),
});

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators(actionCreators, dispatch),
  ...actionCreatorsDispatchedManually(dispatch, props),
});

export default connect(mapStateToProps, mapDispatchToProps)(utils.toJS(VehicleSelectDetailsCard));
